import {
  Button,
  Caption1,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { ChevronLeftRegular, ChevronRightRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  pager: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalS,
    padding: tokens.spacingHorizontalL,
  },
  summary: { color: tokens.colorNeutralForeground3 },
});

export interface PagerProps {
  readonly page: number;
  readonly totalPages: number;
  readonly totalItems: number;
  /** Nome dos itens no plural, para o resumo (`caixas`). */
  readonly noun: string;
  onPage(page: number): void;
}

/** Resumo e navegação de uma lista paginada pelo servidor. */
export function Pager({
  page,
  totalPages,
  totalItems,
  noun,
  onPage,
}: PagerProps) {
  const styles = useStyles();
  return (
    <nav className={styles.pager} aria-label="Paginação">
      <Caption1 className={styles.summary}>
        Página {page} de {Math.max(totalPages, 1)} · {totalItems} {noun}
      </Caption1>
      <Button
        icon={<ChevronLeftRegular />}
        disabled={page <= 1}
        onClick={() => onPage(page - 1)}
      >
        Anterior
      </Button>
      <Button
        icon={<ChevronRightRegular />}
        iconPosition="after"
        disabled={page >= totalPages}
        onClick={() => onPage(page + 1)}
      >
        Próxima
      </Button>
    </nav>
  );
}
